import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FeeCategory, GeneralFee } from '../models';

@Injectable()
export class FeeService  {
  constructor(private http: HttpClient) { }

  async getCategory(category: FeeCategory): Promise<GeneralFee[]> {
    return await this.http.get<GeneralFee[]>(`fee/category/${category}`).toPromise();
  }
}
